import { Outlet } from "react-router-dom";

const MainBidding = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainBidding;